import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AuthUserService = /** @class */ (function () {
    function AuthUserService(httpClient) {
        this.httpClient = httpClient;
        this._url = environment.apiUrl;
    }
    AuthUserService.prototype.sendAuthData = function (actionName, data) {
        return this.httpClient.post(this._url.concat(actionName), data, {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        });
    };
    AuthUserService.ngInjectableDef = i0.defineInjectable({ factory: function AuthUserService_Factory() { return new AuthUserService(i0.inject(i1.HttpClient)); }, token: AuthUserService, providedIn: "root" });
    return AuthUserService;
}());
export { AuthUserService };
